import { Component, Input } from '@angular/core';
import { Item } from '../../../../interfaces/item';
import { NamelizePipe } from '../../../../pipes/transforms/namelize.pipe';

@Component({
  selector: 'app-mostrar-item',
  templateUrl: './mostrar-item.component.html'
})
export class MostrarItemComponent {
  private _item: Item;
  public item_etiqueta: string = "";

  // indica si el ítem se está mostrando en una impresión 
  @Input() imprimiendo: boolean = false;

  @Input()
  public get item(): Item {
    return this._item;
  }
  public set item(v: Item) {
    this.item_etiqueta = (v.etiqueta || v.producto.tipo.descripcion);
    this.item_etiqueta = this.item_etiqueta.toUpperCase();
    this._item = v;
  }

  constructor(
    private namelizePipe: NamelizePipe
  ) { }

  /**
   * cambia el tipo de letra entre
   * Mayúscula, Minúscula, Original, Nombre
   */
  caseActual = "MAYUSCULA";
  cambiarCase() {
    switch (this.caseActual) {
      case "MAYUSCULA":
        this.caseActual = "MINUSCULA";
        this.item_etiqueta = this.item_etiqueta.charAt(0).toUpperCase() + this.item_etiqueta.slice(1).toLowerCase();
        break;
      case "MINUSCULA":
        this.caseActual = "NOMBRE";
        this.item_etiqueta = this.namelizePipe.transform(this.item_etiqueta);
        break;
      case "NOMBRE":
        this.caseActual = "ORIGINAL";
        this.item_etiqueta = (this.item.etiqueta || this.item.producto.tipo.descripcion);
        break;
      case "ORIGINAL":
        this.caseActual = "MAYUSCULA";
        this.item_etiqueta = this.item_etiqueta.toUpperCase();
        break;
    }
  }

  caracteristicasOrdenadas(caracteristicas) {
    return caracteristicas.sort((a, b) => {
      if (a.ordenImpresion > b.ordenImpresion) {
        return 1;
      }
      if (a.ordenImpresion < b.ordenImpresion) {
        return -1;
      }
      return 0;
    });
  }
}
